import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPassword = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 19,
	viewBox: "0 0 38 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 4.5,
			cy: 9.5,
			r: 4.5,
			fill: "#8758FF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 16.5,
			cy: 9.5,
			r: 4.5,
			fill: "#8758FF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 28.5,
			cy: 9.5,
			r: 4.5,
			fill: "#8758FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.5 1C35.5 0.447715 35.9477 0 36.5 0C37.0523 0 37.5 0.447715 37.5 1V18C37.5 18.5523 37.0523 19 36.5 19C35.9477 19 35.5 18.5523 35.5 18V1Z",
			fill: "#5D616B"
		})
	]
});
export default SvgPassword;
